import { createGlobalStyle } from "styled-components";

const styled = { createGlobalStyle };

const GlobalStyles = styled.createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: transparent;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard */
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  html {
    height: 100%;
    font-size: 62.5%; // 1rem = 10px, 10/16 = 60.25%
    box-sizing: border-box;
    font-family: Figtree;
    user-select: none;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern" 1;
  }

  body {
    box-sizing: border-box;
    background-color: rgb(3, 5, 8);

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Site-wide blue backdrop. A fixed layer (instead of background-attachment:
     fixed, which iOS ignores) so the gradient always spans exactly one
     viewport regardless of page length or scroll position. Layout containers
     stay transparent so this shows through on every page. */
  body::before {
    content: "";
    position: fixed;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgb(19, 35, 58) 0%,
      rgb(13, 21, 33) 10.25%,
      rgb(10, 26, 47) 80.12%,
      rgb(3, 5, 8) 100%
    );
  }

  /* Skeleton placeholders tokom loading-a */
  img[loading="lazy"]:not([src]) {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 25%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0.05) 75%
    );
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  input,
  button,
  select {
    outline: none;
  }

  #cf-turnstile {
    width: 100% !important;
    max-width: 100%;
    display: block;
  }
  #cf-turnstile > div {
    width: 100% !important;
    display: flex;
    justify-content: center;
  }

  li {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    #cf-turnstile {
      scale: 0.925;
    }
    #cf-turnstile > div {
      scale: 0.925;
    }
  }

  .tg-auth-button {
    height: 42px !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    text-align: center !important;
    font-family: Figtree !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    letter-spacing: -0.21px !important;
    border-radius: 100px !important;
    border: 1px solid #76baef !important;
    background: #54a9eb !important;
    color: #fff !important;
  }
`;

export default GlobalStyles;
